import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { Card, Modal } from "react-bootstrap";
import moment from "moment";
import { academydetail, academylist, admincountdashboard, dobreportlist, listevent, listsetting } from "../../services/admin";
import { roleList } from "../../services/master";
import { pushcreate } from "../../services/common";
import { toast } from "react-toastify";
import Select from "react-select";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { AgGridReact } from "ag-grid-react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    ArcElement,
    BarElement,    // Add this for Bars
    Title,
    Tooltip,
    Legend
} from 'chart.js';


import { Pie, Bar } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    ChartDataLabels,
    Title,
    Tooltip,
    Legend
);
function SuperAdminDashboard() {

    const navigate = useNavigate();
    const [role, setRole] = useState("");
    const [academy, setAcademy] = useState("");
    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");
    const [adate, setADate] = useState("");

    const [clist, setCList] = useState([]);
    const [totlist, setTotList] = useState("");

    const [studet, setStuDet] = useState("");
    const [teadet, setTeaDet] = useState("");
    const [hosdet, setHosDet] = useState("");
    const [aldet, setAlDet] = useState("");
    const [tdet, setTDet] = useState("");


    const [wordet, setWorDet] = useState("");
    const [feedet, setFeeDet] = useState("");
    const [incdet, setIncDet] = useState("");
    const [expdet, setExpDet] = useState("");
    const [enqdet, setEnqDet] = useState("");
    const [comdet, setComDet] = useState("");
    const [tpath, setTPath] = useState("");

    const [annlist, setAnnList] = useState([]);
    const [ulist, setUList] = useState([]);
    const [elist, setEList] = useState([]);
    const [nlist, setNList] = useState([]);
    const [pchart, setPChart] = useState([]);
    const [bchart, setBChart] = useState([]);
    const [blist, setBList] = useState([]);
    const [bpath, setBPath] = useState("");
    const [bsending, setBSending] = useState(false);

    const columnDefs = [
        {
            headerName: "Type",
            field: "type",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Name",
            field: "name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Inv No",
            field: "inv_no",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Inv Date",
            field: "inv_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Amount",
            field: "amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ]
    const [location, setLocation] = useState({ lat: null, lng: null });
    useEffect(() => {


        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });
        const temp = new FormData();
        if (localStorage.getItem("Role") !== "1") {
            temp.append("academy_id", localStorage.getItem("academy"));
        }
        if (localStorage.getItem("Role") === "1") {
            temp.append("role_id", localStorage.getItem("Role"));
        }
        listsetting(temp).then((resp) => {
            if (resp.status === true) {
                if (resp.data !== null) {
                    localStorage.setItem("AYear", resp.data.year_id);
                    localStorage.setItem("ADate", resp.data.academy_date !== null ? resp.data.academy_date : '');
                    localStorage.setItem("AAcademy", resp.data.academy_id);
                    setADate(resp.data.academy_date ? resp.data.academy_date : moment(new Date()).format("YYYY-MM-DD"));
                    academylist().then((res) => {
                        if (res.status === true) {
                            let arr = [];
                            if (res.data.details.length > 0) {
                                for (let i = 0; i < res.data.details.length; i++) {
                                    if (res.data.details[i].id === resp.data.academy_id) {
                                        arr.push({
                                            value: res.data.details[i].id,
                                            label:
                                                res.data.details[i].name + " - " + res.data.details[i].code,
                                        });
                                    }
                                    setAcaID(arr[0]);
                                }
                            }
                            if (arr.length > 0) {
                                getdetail(arr[0], resp.data.academy_date ? resp.data.academy_date : moment(new Date()).format("YYYY-MM-DD"));
                            }

                        }
                    });
                } else {
                    setADate(moment(new Date()).format("YYYY-MM-DD"));
                    if (resp.data !== null) {
                        academylist().then((res) => {
                            if (res.status === true) {
                                let arr = [];
                                if (res.data.details.length > 0) {
                                    for (let i = 0; i < res.data.details.length; i++) {
                                        if (res.data.details[i].id === resp.data.academy_id) {
                                            arr.push({
                                                value: res.data.details[i].id,
                                                label:
                                                    res.data.details[i].name + " - " + res.data.details[i].code,
                                            });
                                        }
                                        setAcaID(arr[0]);
                                    }
                                }
                                if (arr.length > 0) {
                                    getdetail(arr[0], moment(new Date()).format("YYYY-MM-DD"));
                                }

                            }
                        });
                    }

                }

            }
        })
        if (navigator.geolocation) {
            // navigator.geolocation.getCurrentPosition(
            //     (position) => {
            //         setLocation({
            //             lat: position.coords.latitude,
            //             lng: position.coords.longitude
            //         });
            //     },
            //     (error) => {
            //         console.log("Error getting location:", error);
            //     }
            // );
            const watchId = navigator.geolocation.watchPosition(
                (position) => {
                    setLocation({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    });
                },
                (err) => {
                    console.log(err.message);
                },
                {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                }
            );

            return () => navigator.geolocation.clearWatch(watchId);
        } else {
            console.log("Geolocation is not supported by this browser.");
        }

    }, []);
    const startAutoScroll = () => {
        const scrollContainer = document.getElementById('auto-scroll');

        const scrollSpeed = 1;

        if (scrollContainer) {
            window.scrollInterval = setInterval(() => {
                scrollContainer.scrollTop += scrollSpeed;

                if (scrollContainer.scrollTop >= nlist.scrollHeight) {
                    scrollContainer.scrollTop = 0;
                }
            }, 30);
        }
    };

    // Start auto-scrolling on page load
    document.addEventListener('DOMContentLoaded', startAutoScroll);

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            getdetail(e, adate);
        } else {
            setAcaID("");
            getdetail("", adate);
        }
    }

    function getdetail(gid, gdate) {
        setADate(gdate)
        academydetail(gid.value).then((res) => {
            if (res.status === true) {
                if (res.data.details.name !== null) {
                    setAcademy(res.data.details.name);
                } else {
                    setAcademy("");
                }
            }
        });
        const temp = new FormData();
        temp.append("academy_id", gid.value);
        temp.append("date", gdate);
        admincountdashboard(temp).then((res) => {
            if (res.status === true) {
                console.log(res.data);
                setTPath(res.data.path);
                setStuDet(res.data.students);
                setTeaDet(res.data.teachers);
                setHosDet(res.data.hostel);
                setAlDet(res.data.alumni);
                setTDet(res.data.transport);

                setWorDet(res.data.workers);
                setFeeDet(res.data.fees);
                setIncDet(res.data.incomedet);
                setExpDet(res.data.expensedet);
                setEnqDet(res.data.enquiry);
                setComDet(res.data.complaint);
                setCList(res.data.class_sections);
                if (res.data.class_sections.length > 0) {
                    const grandTotals = res.data.class_sections.reduce(
                        (classAcc, classItem) => {
                            const sectionTotals = classItem.section.reduce(
                                (sectionAcc, section) => {
                                    sectionAcc.morning_present += section.morning_present;
                                    sectionAcc.morning_absent += section.morning_absent;
                                    sectionAcc.evening_present += section.evening_present;
                                    sectionAcc.evening_absent += section.evening_absent;
                                    return sectionAcc;
                                },
                                {
                                    morning_present: 0,
                                    morning_absent: 0,
                                    evening_present: 0,
                                    evening_absent: 0,
                                }
                            );

                            // Add this class's section totals to the grand total
                            classAcc.morning_present += sectionTotals.morning_present;
                            classAcc.morning_absent += sectionTotals.morning_absent;
                            classAcc.evening_present += sectionTotals.evening_present;
                            classAcc.evening_absent += sectionTotals.evening_absent;

                            return classAcc;
                        },
                        {
                            morning_present: 0,
                            morning_absent: 0,
                            evening_present: 0,
                            evening_absent: 0,
                        }
                    );

                    setTotList(grandTotals); // ✅ This is now the correct total
                }

                const classLabels = res.data.class_count.map(item => item.name); // e.g., ["I", "II", "III"]
                const classValues = res.data.class_count.map(item => item.value);  // e.g., [10, 20, 15]
                const chartColors = generateDarkColors(classLabels.length);
                const data = {
                    labels: classLabels,
                    datasets: [{
                        data: classValues,
                        backgroundColor: chartColors,
                        borderColor: chartColors, // Dark border to match theme
                        borderWidth: 1,
                    }]
                };
                setPChart(data);

                const data1 = {
                    labels: res.data.classattendance.map(item => ` ${item.class_name}`),
                    datasets: [
                        {
                            label: 'Present',
                            data: res.data.classattendance.map(item => item.present),
                            backgroundColor: 'green',
                        },
                        {
                            label: 'Absent',
                            data: res.data.classattendance.map(item => item.absent),
                            backgroundColor: 'red',
                        },
                        // {
                        //     label: 'Total Students',
                        //     data: res.data.classattendance.map(item => item.total_active_students),
                        //     backgroundColor: 'rgba(54, 162, 235, 0.8)',
                        // }
                    ],
                };
                setBChart(data1);




                setUList(res.data.users);
                // setEList(res.data.incomeexpence)
                if (res.data.incomeexpence.length > 0) {
                    const edata = res.data.incomeexpence.map((item) => {
                        return {
                            ...item,
                            inv_date: moment(item.inv_date).format("DD-MM-YYYY"),
                            type: item.head_type == 2 ? "Expense" : "Income"
                        }
                    })
                    setEList(edata);

                }
                setNList(res.data.notification)
            }
        });
        // Today's birthday wishes list (all roles) for the selected academy and date
        setBList([]);
        roleList().then((rres) => {
            if (!rres || rres.status !== true) {
                return;
            }
            // Roles with id > 3 have date-of-birth records (4 = student, then staff roles)
            const roles = rres.data.filter((r) => r.id > 3);
            Promise.all(
                roles.map((r) => {
                    const btemp = new FormData();
                    btemp.append("from_date", gdate);
                    btemp.append("to_date", gdate);
                    btemp.append("role_id", r.id);
                    if (gid.value) {
                        btemp.append("academy_id", gid.value);
                    }
                    return dobreportlist(btemp).then((res) => {
                        if (res && res.status === true) {
                            if (res.data.path) {
                                setBPath(res.data.path);
                            }
                            return (res.data.details || []).map((item) => ({
                                ...item,
                                role_id: r.id,
                                role_name: r.name,
                            }));
                        }
                        return [];
                    });
                })
            ).then((results) => {
                setBList([].concat(...results));
            });
        });
        setAnnList([]);
        const temp1 = new FormData();
        temp1.append("academy_id", gid.value);
        listevent(temp1).then((res) => {
            if (res.status === true) {
                setAnnList(res.data.details);
            }
        })
    }

    const generateDarkColors = (num) => {
        const colors = [];
        const hueStep = 360 / num;

        for (let i = 0; i < num; i++) {
            const hue = Math.floor(i * hueStep);
            colors.push(`hsl(${hue}, 70%, 40%)`);
        }
        return colors;
    };
    const [cshow, setCShow] = useState(false);
    const [attdata, setAttData] = useState("");
    const [attcls, setAttCls] = useState("");
    function handleAttendance(hdata, hcls) {
        setAttData(hdata);
        setAttCls(hcls);
        setCShow(true);
    }

    function handleClose() {
        setCShow(false);
        setAttData("");
        setAttCls("");
    }



    const [eshow, setEShow] = useState(false);
    const [eventdet, setEventDet] = useState("");
    function handleEvent(hdata) {
        setEventDet(hdata);
        setEShow(true);
    }

    function handleEventClose() {
        setEShow(false);
        setEventDet("");
    }

    const [ashow, setAShow] = useState(false);
    const [admindet, setAdminDet] = useState("");
    function handleAdmin(hdata) {
        setAdminDet(hdata);
        setAShow(true);
    }

    function handleAClose() {
        setAShow(false);
        setAdminDet("");
    }

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState("");
    const openModal = (event) => {
        setSelectedEvent(event);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setSelectedEvent("");
        setModalIsOpen(false);
    };

    const handleEventClick = (info) => {
        const clickedEvent = {
            title: info.event.title,
            start: info.event.start,
            end: info.event.end,
            description: info.event.extendedProps.description,
            location: info.event.extendedProps.location,
            circular: info.event.extendedProps.circular === '' ? "" : info.event.extendedProps.path + info.event.extendedProps.circular,
        };
        openModal(clickedEvent);
    };

    function errorphoto(ev) {
        ev.target.src = require("../../assets/images/teacher.jpg");
        ev.target.onerror = null;
    }

    // Send a "Happy Birthday" push to everyone on today's birthday list. The push
    // endpoint targets one role at a time, so the mixed-role list is grouped by
    // role and one notification is sent per role.
    function sendBirthdayWishes() {
        if (!blist || blist.length === 0) {
            toast.error("No birthdays today to send wishes.");
            return;
        }
        const aca = acaid && acaid.value
            ? acaid.value
            : localStorage.getItem("AAcademy") || localStorage.getItem("academy") || "";
        const today = moment(new Date()).format("YYYY-MM-DD");
        const byRole = {};
        blist.forEach((item) => {
            const rid = item.role_id;
            if (!byRole[rid]) byRole[rid] = [];
            byRole[rid].push(item);
        });
        setBSending(true);
        Promise.all(
            Object.keys(byRole).map((rid) => {
                const people = byRole[rid];
                const temp = new FormData();
                temp.append("title", "Happy Birthday!");
                temp.append("push_sent_role", rid);
                temp.append("priority", "High");
                temp.append("message", "Wishing you a very Happy Birthday! 🎂");
                temp.append("academy_id", aca);
                temp.append("push_file", "");
                temp.append("type", "Birthday");
                temp.append("role_id", rid);
                temp.append("date", today);
                people.forEach((item, index) => {
                    const uid = item.id || item.user_id || item.login_user_id || "";
                    const name = item.student_name || item.teacher_name || item.worker_name || item.name || "";
                    temp.append("student_ids[]", uid);
                    temp.append("student_name_" + (index + 1), name);
                });
                return pushcreate(temp);
            })
        )
            .then((results) => {
                setBSending(false);
                const ok = results.some((r) => r && r.status === true);
                if (ok) {
                    toast.success("Birthday wishes sent.");
                } else {
                    toast.error("Could not send birthday wishes.");
                }
            })
            .catch(() => {
                setBSending(false);
                toast.error("Could not send birthday wishes.");
            });
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: 40 // Extra space so labels don't get cut off
        },
        plugins: {
            legend: {
                // Hide the default legend to avoid cluttering with external labels
                display: false,
            },
            title: {
                display: false,
            },
            datalabels: {
                color: '#000', // White text
                // backgroundColor: (context) => context.dataset.backgroundColor, // Match slice color
                // borderRadius: 4,
                // padding: 6,
                anchor: 'end',
                align: 'end',
                offset: 25, // Give the line room to breathe
                formatter: (value, context) => {
                    const label = context.chart.data.labels[context.dataIndex];
                    return `${label} : ${value}`;
                },
                font: {
                    weight: 'bold',
                    size: 11
                }
                // color: '#000000',
                // anchor: 'end',
                // align: 'end',
                // offset: 40,
                // formatter: (value, context) => {
                //     const label = context.chart.data.labels[context.dataIndex];
                //     return `${label} : ${value}`;
                // },
                // font: {
                //     weight: 'bold',
                //     size: 12
                // },
            }
        }
    };
    const lineConnectorPlugin = {
        id: 'lineConnector',
        afterDraw: (chart) => {
            const { ctx, chartArea: { width, height } } = chart;
            chart.data.datasets.forEach((dataset, i) => {
                chart.getDatasetMeta(i).data.forEach((datapoint, index) => {
                    const { x, y, startAngle, endAngle, outerRadius } = datapoint;
                    const midAngle = startAngle + (endAngle - startAngle) / 2;

                    // Calculate line start (edge of the pie)
                    const startX = x + Math.cos(midAngle) * outerRadius;
                    const startY = y + Math.sin(midAngle) * outerRadius;

                    // Calculate line end (where the label is)
                    // Match this '20' with your datalabels 'offset'
                    const endX = x + Math.cos(midAngle) * (outerRadius + 20);
                    const endY = y + Math.sin(midAngle) * (outerRadius + 20);

                    ctx.save();
                    ctx.beginPath();
                    ctx.moveTo(startX, startY);
                    ctx.lineTo(endX, endY);
                    ctx.strokeStyle = dataset.backgroundColor[index]; // Same color as slice
                    ctx.lineWidth = 2;
                    ctx.stroke();
                    ctx.restore();
                });
            });
        }
    };

    const baroptions = {
        indexAxis: 'y', // Keep this for left-to-right format
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',

            },
            datalabels: {
            color: '#ffffff', // White color for the counts
            anchor: 'end',    // Positions label at the end of the bar
            align: 'start',   // Keeps label inside the bar
            font: {
                weight: 'bold',
                size: 12
            },
            formatter: (value) => {
                return value; // Displays the actual number
            }
        }
        },
        scales: {
            // This is your horizontal axis (the numbers)
            x: {

                display: true,
                title: {
                    display: true,
                    text: 'Counts', // Name for the X-axis
                    color: '#666',
                    font: {
                        size: 14,
                        weight: 'bold',
                    }
                },
                beginAtZero: true
            },
            // This is your vertical axis (the class names)
            y: {
                display: true,
                title: {
                    display: true,
                    text: 'Class', // Name for the Y-axis
                    color: '#666',
                    font: {
                        size: 14,
                        weight: 'bold',
                    }
                }
            }
        }
    };
    return (
        <Fragment>
            <div className="main-container container-fluid">
                <div className="inner-body">
                    {/* Page Header */}
                    <div className="page-header">
                        <h2 className="main-content-title tx-24 mg-b-5">
                            Welcome To Dashboard
                        </h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a>Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Dashboard
                            </li>
                        </ol>
                    </div>
                    {/* End Page Header */}
                    {/*Row*/}
                    <div className="row row-sm">
                        <div className="col-sm-12 col-lg-12 col-xl-8">
                            {/*Row*/}
                            <div className="card mb-3">

                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12">
                                            <div className="row">
                                                {localStorage.getItem("Role") == 1 &&
                                                    <div className="col-xl-6 col-sm-6">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                Select Academy<span className="text-danger"> *</span>
                                                            </label>
                                                            <Select
                                                                className="default-select"
                                                                placeholder="Select Academy"
                                                                value={acaid}
                                                                options={alist}
                                                                onChange={handleAcademy}
                                                                isSearchable={true}
                                                                isClearable
                                                                hidden
                                                            />
                                                        </div>
                                                    </div>
                                                }

                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Select Date<span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            id="date"
                                                            name="date"
                                                            className="form-control"
                                                            value={adate}
                                                            onChange={(e) => getdetail(acaid, e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div className="row row-sm  mt-lg-4">
                                <div className="col-sm-12 col-lg-12 col-xl-12">
                                    <div className="bg-black-2 custom-card card-box card">
                                        <div className="card-body p-4">
                                            <div className="row align-items-center">
                                                <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 img-bg ">
                                                    <h4 className="d-flex  mb-3">
                                                        <span className="font-weight-bold text-white ">
                                                            {academy === ""
                                                                ? "AMY Technologies"
                                                                : `${academy}`}
                                                        </span>
                                                    </h4>
                                                    <p className="tx-white-7 mb-1">
                                                        Welcome Back{" "}
                                                        <b className="text-warning">
                                                            {localStorage.getItem('Role') == 1
                                                                ? "Super Admin"
                                                                : `${role}`}
                                                        </b>{" "}
                                                        See our Today's Dashboard{" "}
                                                        <b className="text-warning">
                                                            {adate ? moment(adate).format("DD-MM-YYYY") : ''}
                                                        </b>
                                                        <br></br>
                                                        Have a Nice Day
                                                    </p>
                                                </div>
                                                <img
                                                    src={require("../../assets/images/dashboard/super admin.png")}
                                                    alt="Student"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/*Row */}
                            {/*Row*/}
                            <div className="col-sm-12 col-lg-12 col-xl-12">
                                <div className="row row-sm">

                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >STUDENTS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-primary">{studet ? studet.total_students : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Total</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-success">{totlist ? totlist.evening_present != 0 ? totlist.evening_present : totlist.morning_present : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Present</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-danger">{totlist ? totlist.evening_absent != 0 ? totlist.evening_absent : totlist.morning_absent : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Absent</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >TEACHERS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-primary">{teadet ? teadet.total_teachers : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Total</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-success">{teadet ? teadet.evening_present != 0 ? teadet.evening_present : teadet.morning_present : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Present</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-danger">{teadet ? teadet.evening_absent != 0 ? teadet.evening_absent : teadet.morning_absent : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Absent</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >WORKERS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-primary">{wordet ? wordet.total_workers : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Total</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-success">{wordet ? wordet.evening_present != 0 ? wordet.evening_present : wordet.morning_present : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Present</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a className="text-danger">{wordet ? wordet.evening_absent != 0 ? wordet.evening_absent : wordet.morning_absent : "0"}</a>{" "}
                                                        <p className="text-muted tx-14">Absent</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a  >FEE COLLECTION</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >₹ {feedet ? feedet.total_amount : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Today</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >₹ {feedet ? feedet.paid_amount : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Paid</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a> ACCOUNTS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >₹ {incdet ? incdet : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Income</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >₹ {expdet ? expdet : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Expenses</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >ADMISSION</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >456</a>{" "}
                                                        <p className="text-muted tx-16">Today</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >556</a>{" "}
                                                        <p className="text-muted tx-16">Total</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >ENQUIRY</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{enqdet ? enqdet.today_enquiry : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Today</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{enqdet ? enqdet.total_enquiry : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Total</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >COMPLAINTS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>{comdet ? comdet.today_complaint : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Today</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>{comdet ? comdet.total_complaint : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Total</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >HOSTEL</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{hosdet ? hosdet.boys : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Boys</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{hosdet ? hosdet.girls : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Girls</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >ALUMNI</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{aldet ? aldet.boys : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Boys</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{aldet ? aldet.girls : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Girls</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >TRANSPORT</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{tdet ? tdet.boys : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Boys</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{tdet ? tdet.girls : "0"}</a>{" "}
                                                        <p className="text-muted tx-16">Girls</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6 col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >TRANSPORT</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >456</a>{" "}
                                                        <p className="text-muted tx-16">Allocate Student</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >556</a>{" "}
                                                        <p className="text-muted tx-16">Total</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="row row-sm" style={{ width: '600px', maxHeight: '350px', }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <h1 style={{ margin: '0', fontSize: '18px', fontWeight: 'bold' }}>
                                            Student Strength Analysis
                                        </h1>
                                        <h5 style={{ margin: '0', fontSize: '16px', fontWeight: 'bold' }}>
                                            Class Wise - Strength
                                        </h5>
                                    </div>

                                    {/* The Chart Logic */}
                                    {pchart && pchart.datasets ? (
                                        <Pie data={pchart} options={options} plugins={[ChartDataLabels, lineConnectorPlugin]} />
                                    ) : (
                                        <p style={{ textAlign: 'center' }}>Loading Chart...</p>
                                    )}
                                </div>
                                <div className="row row-sm mt-5">    </div>
                                <div className="row row-sm mt-5">    </div>

<div className="row row-sm" style={{maxHeight: '350px', }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <h1 style={{ margin: '0', fontSize: '18px', fontWeight: 'bold' }}>
                                            Student Strength Analysis
                                        </h1>
                                        <h5 style={{ margin: '0', fontSize: '16px', fontWeight: 'bold' }}>
                                            Class Wise Attendance
                                        </h5>
                                    </div>

                                    {/* The Chart Logic */}
                                    {bchart && bchart.datasets ? (
                                        <Bar data={bchart} options={baroptions} />
                                    ) : (
                                        <p style={{ textAlign: 'center' }}>Loading Chart...</p>
                                    )}
                                </div>

                                <div className="row row-sm mt-5">
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <Card className="custom-card">
                                            <Card.Header className="">
                                                <div className="d-md-flex ms-auto w-100 align-items-center">
                                                    <label className="main-content-label my-auto pt-2"><i className="fa fa-birthday-cake headericons"></i> Today Birthday List</label>
                                                    {blist.length > 0 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-success ms-auto"
                                                            onClick={sendBirthdayWishes}
                                                            disabled={bsending}
                                                        >
                                                            <i className="fa fa-paper-plane me-1"></i>
                                                            {bsending ? "Sending..." : "Send Wishes"}
                                                        </button>
                                                    )}
                                                </div>
                                            </Card.Header>
                                            <Card.Body className="scrollable-body">
                                                {blist.length > 0 ? (
                                                    <ul className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border">
                                                        {blist.map((item, index) => {
                                                            const isStudent = item.role_id == 4;
                                                            const name = item.student_name || item.teacher_name || item.worker_name || item.name || "";
                                                            const photo = item.photo || item.worker_photo;
                                                            return (
                                                                <li key={index} className="media d-flex mb-3 mt-0 pt-0">
                                                                    <img
                                                                        alt="avatar"
                                                                        className="me-3 rounded-circle avatar avatar-md"
                                                                        src={bpath + photo}
                                                                        onError={(e) => errorphoto(e)}
                                                                    />
                                                                    <div className="media-body mb-1 announcement">
                                                                        <div className="float-end">
                                                                            <span className="badge bg-success-light"><i className="fa fa-birthday-cake me-1"></i> Happy Birthday</span>
                                                                        </div>
                                                                        <h5 className="media-title tx-16 mb-0">{name}</h5>
                                                                        {isStudent ? (
                                                                            <p className="mb-0 tx-13 text-muted">
                                                                                {item.class_name} - {item.section_name}
                                                                                {(item.parent_phone || item.phone) ? " | " + (item.parent_phone || item.phone) : ""}
                                                                            </p>
                                                                        ) : (
                                                                            <p className="mb-0 tx-13 text-muted">
                                                                                {item.role_name}
                                                                                {item.phone ? " | " + item.phone : ""}
                                                                            </p>
                                                                        )}
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                ) : (
                                                    <p className="text-center text-muted mb-0">No birthday found</p>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div>


                                {/*  <div className="col-lg-12">
                                    <Card className="custom-card" style={elist.length >= 10 ? {} : { height: 'auto' }}>
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-credit-card headericons"></i> INCOME & EXPENSES</label>

                                            </div>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="ag-theme-alpine ag-style mt-2" style={elist.length >= 10 ? {} : { height: 'auto' }}>
                                                <AgGridReact
                                                    columnDefs={columnDefs}
                                                    rowData={elist}
                                                    pagination="true"
                                                    paginationPageSize="10"
                                                    sortingOrder={["asc", "desc"]}
                                                    suppressDragLeaveHidesColumns={true}
                                                    domLayout={elist.length < 10 ? 'autoHeight' : 'normal'}
                                                />
                                            </div>

                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="col-lg-12">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-group headericons"></i> Vehicle Location</label>

                                            </div>
                                        </Card.Header>
                                        <Card.Body className="scrollable-body">
                                            <div style={{ height: "400px" }}>
                                                <iframe
                                                    width="100%"
                                                    height="100%"
                                                    style={{ border: 0 }}
                                                    src={`https://www.google.com/maps?q=${location.lat},${location.lng}&z=15&output=embed`}
                                                    allowFullScreen=""
                                                    loading="lazy"
                                                    title="Simple Map"
                                                ></iframe>
                                            </div>
                                        </Card.Body>
                                    </Card>


                                </div>*/}
                            </div>

                        </div>
                        {/* col end */}

                        <div className="col-sm-12 col-lg-12 col-xl-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="table-responsive widget-media dlab-scroll height370 ">
                                        <div className="d-md-flex mb-4">
                                            <label className="main-content-title tx-16 mt-3">
                                                ATTENDANCE
                                            </label>
                                            <div className="ms-auto mt-3 d-flex">
                                                <div className="d-flex text-muted tx-13">
                                                    <span className="legend bg-danger rounded-circle" />
                                                    Not Marked
                                                </div>
                                                <div className="d-flex text-muted tx-13">
                                                    <span className="legend bg-success rounded-circle" />
                                                    Marked
                                                </div>
                                            </div>
                                        </div>

                                        <table className="table orderbookTable">
                                            <thead>
                                                <tr>
                                                    <th>Class</th>
                                                    <th>Division</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {clist.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.class}</td>
                                                        <td>
                                                            <div className="btn-group" role="group">
                                                                {item.section.map((data, i) => (
                                                                    <button type="button" className={data.attendance ? "btn btn-success btn-wave" : "btn btn-danger btn-wave"} key={i} onClick={() => handleAttendance(data, item.class)}>
                                                                        {data.section}
                                                                    </button>
                                                                ))}

                                                                {/* <button
                                                                    type="button"
                                                                    className="btn btn-success btn-wave"
                                                                >
                                                                    B
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-wave"
                                                                >
                                                                    C
                                                                </button> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))

                                                }


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="card custom-card mg-t-30">
                                <Card className="custom-card">
                                    <Card.Header className="">
                                        <div className="d-md-flex ms-auto">
                                            <label className="main-content-label my-auto pt-2"> <i className="fa fa-calendar headericons"></i> Events calendar</label>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        {/* <img
                                            alt="avatar"
                                            className=""
                                            src={require("../../assets/images/Screenshot 2024-12-04 123706.png")}
                                        /> */}
                                        <FullCalendar
                                            plugins={[dayGridPlugin]}
                                            initialView="dayGridMonth"
                                            events={annlist.map(event => ({
                                                title: event.event_name,
                                                start: event.event_start,
                                                end: event.event_end,
                                                description: event.description,
                                                location: event.location,
                                                path: event.path,
                                                circular: event.circular,
                                                backgroundColor: '#b04751',
                                                textColor: '#fff'
                                            }))}
                                            eventClick={handleEventClick}
                                        />
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className="row row-sm">
                                <div
                                    className="col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                    data-wow-delay="1.5s"
                                >

                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-group headericons"></i> Academy Staff</label>

                                            </div>
                                        </Card.Header>
                                        <Card.Body className="scrollable-body">
                                            <ul className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border">
                                                {ulist.map((item, index) => (
                                                    <li key={index} className="media d-flex mb-3 mt-0 pt-0">
                                                        <img
                                                            alt="avatar"
                                                            className="me-3 rounded-circle avatar avatar-md"
                                                            src={tpath + item.photo}
                                                            onError={(e) => errorphoto(e)}
                                                        />
                                                        <div className="media-body mb-1 announcement">
                                                            <div className="float-end">
                                                                <a className="me-2 mt-1" onClick={() => handleAdmin(item)}><span className="badge bg-success-light">View</span></a>
                                                            </div>
                                                            <h5 className="media-title tx-16 mb-0">{item.teacher_name}</h5>
                                                            <p className="mb-0 tx-13 text-muted">{academy}</p>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Card.Body>
                                    </Card>

                                </div>
                                <div
                                    className="col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                    data-wow-delay="1.5s"
                                >
                                    <Card className="custom-card">
                                        <Card.Header>
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-bullhorn headericons"></i> Announcement</label>

                                            </div>
                                        </Card.Header>
                                        <Card.Body
                                            id="auto-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            onMouseLeave={startAutoScroll}
                                            style={{
                                                maxHeight: '350px',
                                                overflow: 'auto',
                                                position: 'relative',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="announcement-list"
                                            >
                                                {nlist.map((data, index) => (
                                                    <li key={index} className="d-flex align-items-center mb-3">
                                                        <div className="flex-shrink-0">
                                                            <div className="main-avatar avatar-md online"></div>
                                                        </div>
                                                        <div className="ms-3 flex-grow-1">
                                                            <p className="tx-16 text-dark mb-0 tx-semibold">{data.title}</p>
                                                            <p className="mb-0 text-muted">{moment(data.created_at).format('DD-MM-YYYY')}</p>
                                                        </div>
                                                        <a className="me-2 mt-1" onClick={() => handleEvent(data)}><span className="badge bg-success-light">View</span></a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>


                                {/* col end */}
                            </div>
                        </div>

  
                        <Modal show={cshow} onHide={handleClose}>
                            <Modal.Header>
                                <Modal.Title>{attcls} - {attdata.section}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Total Students</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a className="text-danger">{attdata.total_students}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Morning Present</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a className="text-danger">{attdata.morning_present}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Morning Absent</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a className="text-danger">{attdata.morning_absent}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Evening Present</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a className="text-danger">{attdata.evening_present}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Evening Absent</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a className="text-danger">{attdata.evening_absent}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <a className="btn btn-secondary" onClick={handleClose}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={modalIsOpen} size="md">
                            <Modal.Header>
                                <Modal.Title>Events</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="table-responsive">
                                    <h4>{selectedEvent.title}</h4>
                                    <p><strong>Start Date :</strong> {moment(selectedEvent.start).format('DD-MM-YYYY')}</p>
                                    <p><strong>End Date :</strong> {selectedEvent.end ? moment(selectedEvent.end).format('DD-MM-YYYY') : moment(selectedEvent.start).format('DD-MM-YYYY')}</p>
                                    <p><strong>Location :</strong> {selectedEvent.location}</p>
                                    <p><strong>Description :</strong> {selectedEvent.description}</p>
                                    {selectedEvent.circular !== "" && <p><strong>Circular:</strong> <a href={selectedEvent.circular} target="_blank" rel="noopener noreferrer">View Circular</a></p>}

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <a className="btn btn-info" onClick={closeModal}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>


                        <Modal show={eshow} onHide={handleEventClose}>
                            <Modal.Header>
                                <Modal.Title>Announcement</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Title</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a>{eventdet.title}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Message</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a>{eventdet.message}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <a className="btn btn-secondary" onClick={handleEventClose}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>


                        <Modal show={ashow} onHide={handleAClose}>
                            <Modal.Header>
                                <Modal.Title>Staff Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Name</label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{admindet.teacher_name}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>E-Mail</label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{admindet.email_id}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Mobile</label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{admindet.phone}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <a className="btn btn-secondary" onClick={handleAClose}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>

                    </div>
                    {/* Row end */}
                </div>
            </div>
        </Fragment>
    );
}


export default SuperAdminDashboard;
